<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <purchase-offer-view-header :call-back="updateStatus" />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <b-tabs
          pills
          fill
        >
          <b-tab>
            <template #title>
              <feather-icon icon="InfoIcon" />
              Alınan Teklifler
            </template>
            <purchase-offer-lines-table :refesh-data="getDataItem" />
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="InfoIcon" />
              Satın Alınacak Stoklar
            </template>
            <purchase-offer-items-table />
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col
        cols="12"
        md="12"
        class="text-center mb-2"
      >
        <b-button
          v-if="userData.id === dataItem.id_users && dataItem.id_confirmed_user === null && !['6','7','8'].includes(dataItem.id_purchase_offer_status)"
          class="mr-2"
          variant="warning"
          :to="'/app/purchase-offers/edit/'+dataItem.id"
        >
          <feather-icon icon="EditIcon" />
          Düzenle
        </b-button>
        <b-dropdown
          id="print"
          variant="success"
          class="mr-2"
        >
          <template #button-content>
            <FeatherIcon icon="PrinterIcon" />
            Yazdır
          </template>
          <b-dropdown-item @click="download('tr')">
            Türkçe
          </b-dropdown-item>
          <b-dropdown-item @click="download('en')">
            İngilizce
          </b-dropdown-item>
        </b-dropdown>
        <b-button
          variant="danger"
          class="mr-2"
          @click="toggleMailForm"
        >
          <feather-icon
            v-if="!emailForm"
            icon="ChevronDownIcon"
            class="mr-1"
          />
          <feather-icon
            v-if="emailForm"
            icon="ChevronUpIcon"
            class="mr-1"
          />
          <FeatherIcon icon="MailIcon" />
          E-posta
        </b-button>
      </b-col>
      <b-col
        v-if="emailForm"
        cols="12"
        md="12"
      >
        <purchase-offers-mail-form />
      </b-col>
      <b-col
        v-if="emailForm"
        cols="12"
        md="12"
      >
        <purchase-offers-mail-logs />
      </b-col>
    </b-row>

  </div>
</template>
<script>
import {
  BRow, BCol, BTabs, BTab, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import PurchaseOfferViewHeader from '@/views/Admin/Purchase_offers/Components/ViewHeader.vue'
import PurchaseOfferItemsTable from '@/views/Admin/Purchase_offers/Components/StockItemsTable.vue'
import PurchaseOfferLinesTable from '@/views/Admin/Purchase_offers/Components/OfferLinesTable.vue'
import PurchaseOffersMailForm from '@/views/Admin/Purchase_offers/Components/View/MailForm.vue'
import PurchaseOffersMailLogs from '@/views/Admin/Purchase_offers/Components/View/MailLogs.vue'

export default {
  name: 'View',
  components: {
    PurchaseOffersMailLogs,
    PurchaseOffersMailForm,
    PurchaseOfferLinesTable,
    PurchaseOfferItemsTable,
    PurchaseOfferViewHeader,
    BRow,
    BCol,
    BTabs,
    BTab,
    BDropdown,
    BDropdownItem,
    BButton,
  },
  data() {
    return {
      emailForm: false,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
    lineData() {
      return this.$store.getters['purchaseOfferLines/dataItem']
    },
    linesData() {
      return this.$store.getters['purchaseOfferLines/dataList']
    },
    itemsData() {
      return this.$store.getters['purchaseOfferItems/dataList']
    },

  },
  created() {
    this.getDataItem()
  },
  methods: {
    download(lang) {
      window.open(`${this.$store.state.app.baseURL}/Exports/PurchaseOffers/pdf?token=${localStorage.getItem('downloadToken')}&id=${this.$route.params.id}&lang=${lang}`, '_blank')
    },
    updateStatus() {
      this.$store.dispatch('purchaseOffers/saveData', {
        id: this.dataItem.id,
        id_purchase_offer_status: this.dataItem.id_purchase_offer_status,
      })
        .then(res => {
          if (res.status) {
            this.$swal({
              icon: 'success',
              title: 'İşlem Başarılı',
              text: res.message ? res.message : 'İşlem başarılı.',
              confirmButtonText: 'Kapat',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          } else {
            this.$swal({
              icon: 'error',
              title: 'İşlem Başarısız',
              text: res.message ? res.message : 'İşlem başarısız.',
              confirmButtonText: 'Kapat',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
    },
    getDataItem() {
      this.$store.dispatch('purchaseOffers/getDataItem', { id: this.$route.params.id })
        .then(res => {
          if (res) {
            if (res.id) {
              this.$store.dispatch('purchaseOfferLines/getDataList', {
                select: [
                  'purchase_offer_lines.id AS id',
                  'purchase_offer_lines.odate AS odate',
                  'purchase_offer_lines.price AS price',
                  'purchase_offer_lines.confirmed AS confirmed',
                  'purchase_offer_lines.created AS created',
                  'suppliers.company AS title',
                  'confirmed_user.name AS confirmed_user',
                ],
                where: {
                  'purchase_offer_lines.id_purchase_offers': res.id,
                },
              })
              this.$store.dispatch('purchaseOfferItems/getDataList', {
                select: [
                  'purchase_offer_items.id AS id',
                  'purchase_offer_items.amount AS amount',
                  'stocks.title AS title',
                  'stocks.scode AS scode',
                  'units.title AS units',
                  'stock_groups.title AS stock_groups',
                ],
                where: {
                  'purchase_offer_items.id_purchase_offers': res.id,
                },
              })
            }
          }
        })
    },
    toggleMailForm() {
      this.emailForm = !this.emailForm
    },
  },
}
</script>
